<!-- HEADER & STEPPER -->
<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 mb-6">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Social Posts Section
      </p>
      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        Upload Bulk
      </h2>
    </div>
  </div>

  <!-- Stepper -->
  <div class="w-full 2xl:w-3/4">
    <app-stepper-grid></app-stepper-grid>
  </div>
</div>

<!-- CONTENT WRAPPER -->
<div class="bg-gray-50 px-3 pb-10 min-h-screen pt-6">
  <!-- Content Grid -->
  <div class="grid grid-cols-12 gap-6 items-start">
    <form
      [formGroup]="imagesForm"
      (ngSubmit)="submitImages()"
      class="col-span-12 2xl:col-span-9 p-8 bg-white rounded-3xl border border-gray-300 w-full flex flex-col"
    >

      <div class="text-center mb-2">
        <h1 class="text-3xl font-bold text-gray-800 tracking-tight">Upload New Images</h1>
        <p class="mt-2 text-gray-500">Select new images to upload</p>
      </div>

      <div class="mt-8 flex-grow flex items-center justify-between w-full">
        <div class="flex flex-col p-8 items-center border-2 border-dashed border-gray-300 rounded-2xl text-center transition-colors cursor-pointer hover:border-blue-500 w-full max-w-2xl mx-auto">

          <ng-container *ngIf="uploadedFiles.length === 0">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909"
              />
            </svg>

            <p class="mt-3 text-sm font-medium text-gray-700">Drag & drop images here</p>
            <p class="text-xs text-gray-400 mt-1">or click to browse images</p>

            <button
              type="button"
              class="cursor-pointer mt-4 px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
              (click)="fileInput2.click()"
            >
              Select Files
            </button>
          </ng-container>

          <ng-container *ngIf="uploadedFiles.length > 0">

            <p class="text-sm font-medium text-blue-800 mb-3">
              {{ uploadedFiles.length }} image{{ uploadedFiles.length > 1 ? 's' : '' }} selected
            </p>

            <div class="flex flex-col gap-2 w-full overflow-y-auto max-h-52">
              <div
                *ngFor="let fileObj of uploadedFiles; let i = index"
                class="flex items-center justify-between bg-white border border-blue-100 rounded-xl px-3 py-2"
              >
                <div class="flex items-center gap-3">
                  <div class="w-9 h-9 rounded-md overflow-hidden flex-shrink-0 ring-1 ring-blue-100">
                    <img
                      [src]="fileObj.preview"
                      [alt]="fileObj.alt || fileObj.file?.name"
                      class="w-full h-full object-cover"
                    />
                  </div>

                  <div class="text-left">
                    <p class="text-xs font-medium text-blue-900 truncate max-w-[300px]">
                      {{ fileObj.file?.name }}
                    </p>
                    <p class="text-xs text-blue-400">
                      {{ ((fileObj.file?.size ?? 0) / 1024).toFixed(0) }} KB
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  class="text-red-400 hover:bg-red-50 p-1 rounded-md transition cursor-pointer"
                  (click)="removeFile(i)"
                >
                  <mat-icon class="!text-base">close</mat-icon>
                </button>
              </div>
            </div>

            <div class="flex items-center justify-between w-full mt-3">
              <button
                type="button"
                class="text-xs font-medium text-blue-600 border border-blue-600 px-3 py-1.5 rounded-lg hover:bg-blue-50 transition cursor-pointer"
                (click)="fileInput2.click()"
              >
                + Add more
              </button>

              <button
                type="button"
                class="text-xs font-medium text-red-500 hover:bg-red-50 px-3 py-1.5 rounded-lg transition cursor-pointer"
                (click)="clearAll()"
              >
                Clear all
              </button>
            </div>

          </ng-container>

          <input
            type="file"
            multiple
            (change)="onMultipleFilesSelected($event)"
            accept="image/*"
            class="hidden"
            #fileInput2
          />
        </div>
      </div>

      <div class="mt-8 pt-4 flex justify-end">
        <button
          type="submit"
          class="cursor-pointer inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm font-semibold rounded-lg hover:from-blue-700 hover:to-blue-600 transition-all transform hover:scale-105"
        >
          Next
        </button>
      </div>

    </form>

    <div class="hidden 2xl:block col-span-3 2xl:col-span-3 h-full">
      <app-bulk-sidebar></app-bulk-sidebar>
    </div>
  </div>
</div>